/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { useState, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthConsumer } from "./AuthContext";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { STRIPE_KEY } from "./config";
import RenderFullPageLoading from "./assets/component/RenderFullPageLoading.js";
import PropTypes from "prop-types";

// Initialize Stripe outside component (singleton pattern for performance)
const stripePromise = loadStripe(STRIPE_KEY);

function run(Component, props, isAuth, isOrgAuth, language, t, logout, i18n, requireAuth = false) {
  const currentPath = props.location.pathname.substring(1).toUpperCase();
  //set language Data
  const languageObj = t(currentPath, { returnObjects: true });

  // If authentication is required and user is not authenticated, redirect to login
  if (requireAuth && !isAuth) {
    return <Redirect to="/LoginPrompt" />;
  }

  return (
    <Component
      {...props}
      isAuth={isAuth}
      isOrgAuth={isOrgAuth}
      language={language}
      languageObj={languageObj}
      RenderFullPageLoading={RenderFullPageLoading}
    />
  );
}

const StripeRoute = ({ component: Component, requireAuth = false, ...rest }) => (
  <AuthConsumer>
    {({ isAuth, isOrgAuth, t, language, logout, i18n, requireAuth }) => (
      <Elements stripe={stripePromise}>
        <Route
          render={(props) =>
            run(Component, props, isAuth, isOrgAuth, language, t, logout, i18n, requireAuth)
          }
          {...rest}
        />
      </Elements>
    )}
  </AuthConsumer>
);

StripeRoute.propTypes = {
  component: PropTypes.func,
  requireAuth: PropTypes.bool,
};

export default StripeRoute;
